export const routerUpdatePath = (routerPath) => {
  return { type: "ROUTER_PATH_UPDATE", routerPath };
};

export const requestImages = (docs) => {
  return { type: "IMAGE_FETCH", imageDocs: docs };
};

export const webColorUpdate = (webColor, activeColor) => {
  return {
    type: "WEB_COLOR_CHANGE",
    webColor: webColor,
    activeColor: activeColor,
  };
};
